export enum TranscriberStateEnum {
	START = 'START',
	PAUSE = 'PAUSE',
	RESUME = 'RESUME',
	STOP = 'STOP',
}
